import { SET_OPEN_MODAL_PLANILHA_DIESEL, SET_OPEN_MODAL_PLANILHA_IR_PENSAO_ALIMENTICIA } from "../actions/actionTypes";

const INITIAL_STATE = {
    openModalPlanilhaDiesel: false,
    openModalPlanilhaIrPensaoAlimenticia: false

};

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_OPEN_MODAL_PLANILHA_DIESEL:
            return {
                ...state,
                openModalPlanilhaDiesel: action.payload
            };  
        case SET_OPEN_MODAL_PLANILHA_IR_PENSAO_ALIMENTICIA:
            return {
                ...state,
                openModalPlanilhaIrPensaoAlimenticia: action.payload
            };         
        default:
            return state;
    }
};
